import React from 'react';
import { Center } from 'native-base';
import Pressable from '~/shared/Pressable';
import { H2 } from '~/shared/Typography';
import { useAppNavigate } from '~/pages';
import { AppRouteProps } from '~/pages';
import { useTheme } from '@springbig/shared';

export type CardMenuProps = {
    title: string;
    path?: AppRouteProps;
    handleLogout?: () => void;
    testID?: string;
    toggleMenu?: () => void;
};

const CardMenu = ({ title, path, handleLogout, testID, toggleMenu }: CardMenuProps) => {

    const navigation = useAppNavigate();

    const { menu_background_secondary, menu_text } = useTheme();

    const handlePress = (): void => {

        if (path) {
            toggleMenu && toggleMenu();
            
            path.includes('https://') ? window.open(path, '_blank') : navigation.navigate(path);
        }
    };

    return (
        <Pressable
            testID={testID}
            onPress={handleLogout ? handleLogout : handlePress}
            px={4}
            py={2}
            bg={menu_background_secondary}
            w={'100%'}
        >
            <Center alignItems={'center'} w={'100%'}>
                <H2 color={menu_text}>
                    { title }
                </H2>
            </Center>
        </Pressable>
    );
};

export default CardMenu;
